import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export function Footer() {
  const { t, language, toggleLanguage } = useLanguage();

  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center">
                <span className="text-white font-bold text-lg">P</span>
              </div>
              <span className="font-bold text-xl text-white">PeCash</span>
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/senders"
                  data-testid="footer-senders"
                  className="text-sm text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  {t('nav.senders')}
                </Link>
              </li>
              <li>
                <Link
                  to="/colmados"
                  data-testid="footer-colmados"
                  className="text-sm text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  {t('nav.colmados')}
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  data-testid="footer-about"
                  className="text-sm text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link
                  to="/trust"
                  data-testid="footer-trust"
                  className="text-sm text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  {t('nav.trust')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-white mb-4">{t('footer.legal')}</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/terms"
                  data-testid="footer-terms"
                  className="text-sm text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  {t('footer.terms')}
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  data-testid="footer-privacy"
                  className="text-sm text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link
                  to="/compliance"
                  data-testid="footer-compliance"
                  className="text-sm text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  {t('footer.compliance')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:support@pecashglobal.com"
                  data-testid="footer-email"
                  className="text-sm text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  {t('footer.email')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            &copy; {new Date().getFullYear()} PeCashGlobal. {t('footer.rights')}
          </p>
          
          {/* Language Toggle in Footer */}
          <div className="flex items-center gap-2">
            <Globe className="w-4 h-4 text-slate-500" />
            <button
              onClick={() => language !== 'en' && toggleLanguage()}
              className={`text-sm transition-colors ${
                language === 'en' ? 'text-white font-medium' : 'text-slate-500 hover:text-slate-300'
              }`}
            >
              English
            </button>
            <span className="text-slate-600">|</span>
            <button
              onClick={() => language !== 'es' && toggleLanguage()}
              className={`text-sm transition-colors ${
                language === 'es' ? 'text-white font-medium' : 'text-slate-500 hover:text-slate-300'
              }`}
            >
              Español
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
